export default __webpack_public_path__ + "static/media/portfolio-85.ffcfec7e.jpg";